import type { Channel } from "@/utils/fileImport/channels"
import { ALPHA_QUANTITY_SOLD, ALPHA_VARIANT_ID } from "@/utils/alphaModel"

export const headers = [
  [
    "Sales record number",
    "Order number",
    "Buyer username",
    "Buyer name",
    "Buyer email",
    "Buyer note",
    "Buyer address 1",
    "Buyer address 2",
    "Buyer city",
    "Buyer county",
    "Buyer postcode",
    "Buyer country",
    "Buyer tax identifier name",
    "Buyer tax identifier value",
    "Post to name",
    "Post to phone",
    "Post to address 1",
    "Post to address 2",
    "Post to city",
    "Post to county",
    "Post to postcode",
    "Post to country",
    "Item number",
    "Item title",
    "Custom label",
    "Sold via Promoted listings",
    "Quantity",
    "Sold for",
    "Postage and packaging",
    "Item location",
    "Item postcode",
    "Item country",
    "Included VAT rate",
    "eBay Collect And Remit Tax Rate",
    "eBay Collect And Remit Tax Type",
    "eBay reference name",
    "eBay reference value",
    "Tax status",
    "Seller collected tax",
    "eBay collected tax",
    "Electronic waste recycling fee",
    "Mattress recycling fee",
    "Battery recycling fee",
    "White goods disposal tax",
    "Tyre recycling fee",
    "Additional fee",
    "Total price",
    "eBay collected tax and fees included in total",
    "Payment method",
    "Commitment date",
    "Sale date",
    "Paid on date",
    "Post by date",
    "Minimum estimated delivery date",
    "Maximum estimated delivery date",
    "Dispatched on date",
    "Feedback left",
    "Feedback received",
    "My item note",
    "PayPal transaction ID",
    "Delivery service",
    "Tracking number",
    "Transaction ID",
    "Variation details",
    "Global Shipping Programme",
    "Global Shipping Reference ID",
    "Click and Collect",
    "Click and Collect Reference Number",
    "eBay Plus",
    "Authenticity verification programme",
    "Authenticity verification status",
    "Authenticity verification outcome reason",
    "eBay Fulfilment Programme",
    "Tax city",
    "Tax county",
    "Tax postcode",
    "Tax country",
  ],
  [
    "Sales record number",
    "Order number",
    "Buyer username",
    "Buyer name",
    "Buyer email",
    "Buyer note",
    "Buyer address 1",
    "Buyer address 2",
    "Buyer city",
    "Buyer county",
    "Buyer postcode",
    "Buyer country",
    "Buyer tax identifier name",
    "Buyer tax identifier value",
    "Post to name",
    "Post to phone",
    "Post to address 1",
    "Post to address 2",
    "Post to city",
    "Post to county",
    "Post to postcode",
    "Post to country",
    "Item number",
    "Item title",
    "Custom label",
    "Sold via Promoted listings",
    "Quantity",
    "Sold for",
    "Postage and packaging",
    "Item location",
    "Item postcode",
    "Item country",
    "Included VAT rate",
    "eBay Collect And Remit Tax Rate",
    "eBay Collect And Remit Tax Type",
    "eBay reference name",
    "eBay reference value",
    "Tax status",
    "Seller collected tax",
    "eBay collected tax",
    "Electronic waste recycling fee",
    "Mattress recycling fee",
    "Battery recycling fee",
    "White goods disposal tax",
    "Tyre recycling fee",
    "Additional fee",
    "Total price",
    "eBay collected tax and fees included in total",
    "Payment method",
    "Sale date",
    "Paid on date",
    "Post by date",
    "Minimum estimated delivery date",
    "Maximum estimated delivery date",
    "Dispatched on date",
    "Feedback left",
    "Feedback received",
    "My item note",
    "PayPal transaction ID",
    "Delivery service",
    "Tracking number",
    "Transaction ID",
    "Variation details",
    "Global Shipping Programme",
    "Global Shipping Reference ID",
    "Click and Collect",
    "Click and Collect Reference Number",
    "eBay Plus",
    "Authenticity verification programme",
    "Authenticity verification status",
    "Authenticity verification outcome reason",
    "eBay Fulfilment Programme",
    "Tax city",
    "Tax county",
    "Tax postcode",
    "Tax country",
  ],
]

const channel: Channel = {
  headers,
  dateFormats: {
    Date: "DMY",
  },
  blockMap: {
    [ALPHA_QUANTITY_SOLD]: {
      target: "Quantity",
      columns: {
        [ALPHA_VARIANT_ID]: "Item title",
        Date: "Sale date",
      },
      notInFile: {
        Channel: "eBay",
      },
    },
  },
}

export default channel
